import { joinParts } from '../utils'

export const otp = {
  flow: (phonePrefix: string) => joinParts('otp', 'flow', phonePrefix),
}
